export const BASE_API_URL = `https://${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}/${process.env.REACT_APP_API_URL}`;
// eslint-disable-next-line no-console
console.info(`BASE_API_URL: ${BASE_API_URL}`);
